export const RoomStatus = {
  Available: 'available',
  Deleted: 'deleted',
  NoAccess: 'no_access',
} as const

export type RoomStatus = (typeof RoomStatus)[keyof typeof RoomStatus]
